import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * @title Stepper overview
 */
@Component({
    selector: 'app-modal-tour-mobile',
    templateUrl: './modal-tour-mobile.component.html',
    styleUrls: ['./modal-tour-mobile.component.scss'],
    standalone: false
})

export class ModalTourMobileComponent {

	@Input() slides: any[];

	@Output() onDismissal = new EventEmitter<any>();

	constructor() { }

	dismiss(): void {
		this.onDismissal.emit(true);
	}
}